import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "LoggingUtils"*/ './lazyIndex'),
    { name: 'LoggingUtils' }
);

export const lazyGetHashedLogString: LazyAction<
    typeof lazyIndex.getHashedLogString,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getHashedLogString);

export const lazyLogQueryDuplication: LazyAction<
    typeof lazyIndex.logQueryDuplication,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logQueryDuplication);
